<template lang="pug">
  div
    label(class='u-mb1 u-block' v-if='label', :class='labelClass') {{label}}

    div(:class='wrapperClass')
      input(
        type='file', :name='name', ref='input', :accept="accept"
        @change='updateImage', :class="{inputClass, 'u-border-warning' : message}")

      label(:class="[{'u-border-warning' : message}, {'placeholder' : title === placeholder}]", ) {{title}}&nbsp;

      i(class='u-icon' v-if='icon') {{icon}}

    p(v-html='info' v-if='info' class='u-color-text u-fz-h6 u-mt1 u-mb0' style='font-size:12px;user-select: none;')
    span(v-if='message' class='u-fz-h6 u-pt1 u-pl1 u-block', :class='errorClass') {{message}}
</template>

<script>
  import Validator from 'validatorjs'

  export default {
    props: {
      inputClass: String,
      wrapperClass: String,
      label: String,
      info: String,
      labelClass: String,
      name: String,
      placeholder: String,
      validation: Boolean,
      icon: String,
      clear: Boolean,
      value: {
        type: Object,
        default () {
          return {
            extension: '',
            base64: ''
          }
        }
      },
      accept: {
        type: String,
        default: 'image/png,image/jpeg'
      },
      errorClass: {
        type: String,
        default: 'u-color-error'
      },
      rule: {
        type: String,
        default: 'required'
      }
    },

    data () {
      return {
        image: this.value,
        title: this.placeholder,
        validated: false,
        message: ''
      }
    },

    methods: {
      updateImage (e) {
        let files = e.target.files || e.dataTransfer.files
        let self = this

        let reader = new window.FileReader()
        reader.onload = () => {
          self.image = {
            base64: reader.result,
            extension: files[0].type.split('/')[1]
          }

          // window.open(reader.result)
          self.title = files[0].name
          self.$emit('update', self.image)
          self.validate()
        }

        reader.readAsDataURL(files[0])
      },

      // updateValue (value) {
      //   this.$emit('input', value)
      //   this.validate()
      // },

      validate () {
        if (this.rule) {
          let validate = new Validator({value: this.$refs.input.value}, {value: this.rule})
          this.validated = validate.passes()
          this.message = validate.errors.first('value')
        }
      }
    },

    watch: {
      validation (val, oldVal) {
        this.validate()
      },

      clear (val) {
        this.title = this.placeholder
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/FileValidate.vue